const selectElement = document.querySelector('.js-archive-select');


if(selectElement) {
  selectElement.addEventListener('change', (event) => {
    window.location.href = event.target.value;
  });
}